import axios from 'axios';
import authHeader from './auth.header';
const API_URL = 'https://contabilidadelider.com/api/agenda';

class ContatoService {
  getPublicContent() {
    return axios.get(API_URL + 'all');
  }

  getInfoContato() {
    return axios.get(API_URL, { headers: authHeader() });
  }
  listarContato() {
    return axios.get(API_URL + "/listarContatos", { headers: authHeader() });
  }
  editarContato(id, nome, telefone, celular, email, complementares) {
    return axios.post(
      API_URL + "/editarContato", {
      id: id,
      nome: nome,
      telefone: telefone,
      celular: celular,
      email: email,
      complementares: complementares,
    },
      { headers: authHeader() }
    );
  }
  addContato(nome, telefone, celular, email, complementares) {
    return axios.post(
      API_URL + "/adicionarContato", {
      nome: nome,
      telefone: telefone,
      celular: celular,
      email: email,
      complementares: complementares
    },
      { headers: authHeader() }
    );
  }
  removerContato(id) {
    return axios.post(
      API_URL + "/removerContato", {
      id: id,
    },
      { headers: authHeader() }
    );
  }
  infoContato(nome) {
    return axios.post(
      API_URL + "/infoContato", {
      nome: nome,
    },
      { headers: authHeader() }
    );
  }
}

export default new ContatoService();